// extracted by mini-css-extract-plugin
export default {"events_section":"MainEvents_events_section__azL59","heading":"MainEvents_heading__M5cAD","events_container":"MainEvents_events_container__wV2rN","eventt":"MainEvents_eventt__tCYy8"};